import React from 'react';
import styles from './TranslationModeBar.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { changeTranslationMode } from '../../store/actions/settings';

const TranslationModeBar = () => {
    const dispatch = useDispatch();
    const translationMode = useSelector(state => state.settings.translationMode);

    const turnOffTranslationMode = () => {
        dispatch(changeTranslationMode(false));
    };

    return (
        translationMode && (
            <div className={styles.translationModeBar}>
                <span>Translation Mode</span>
                <button
                    className={`icon-close-thin ${styles.closeButton}`}
                    onClick={turnOffTranslationMode}
                />
            </div>
        )
    );
};

export default TranslationModeBar;
